
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import SmashableMarkerCrate from "../../editor/entity-markers/SmashableMarkerCrate";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformMarkerLogKnot from "../../editor/platform-markers/shipwreck/PlatformMarkerLogKnot";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import CheckpointMarker from "../../editor/CheckpointMarker";
import PlatformMarkerBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerBarrel";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunkHard4 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 384);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 221, 267);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 4462, 267);
    this.add(editor_bounds_right);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, 541, 139);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, 283, 139);
    this.add(pole_long_float_png);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2947, -87);
    this.add(gemMarker_3);

    // crateMarker
    const crateMarker = new SmashableMarkerCrate(scene, 1457, -123);
    this.add(crateMarker);

    // pole_long_float_png_4
    const pole_long_float_png_4 = new DecorationFloatingPoleLong(scene, 1425, 142);
    this.add(pole_long_float_png_4);

    // pole_long_float_png_5
    const pole_long_float_png_5 = new DecorationFloatingPoleLong(scene, 1862, 142);
    this.add(pole_long_float_png_5);

    // pole_long_float_png_6
    const pole_long_float_png_6 = new DecorationFloatingPoleLong(scene, 2602, 140);
    this.add(pole_long_float_png_6);

    // platformMarkerLogKnot
    const platformMarkerLogKnot = new PlatformMarkerLogKnot(scene, 1647, 12);
    this.add(platformMarkerLogKnot);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 1768, -107);
    this.add(gemMarker_7);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 3695, -110);
    this.add(gemMarker_10);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 3979, -120);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 546, -66);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 826, -64);
    this.add(gemMarker_14);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 2738, -45);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 3749, -39);
    this.add(megaGemMarker_1);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 1576, -40);
    this.add(megaGemMarker_2);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, 693, -2);
    this.add(platformMarkerLogLong);

    // pole_long_float_png_8
    const pole_long_float_png_8 = new DecorationFloatingPoleLong(scene, 832, 139);
    this.add(pole_long_float_png_8);

    // pole_long_float_png_9
    const pole_long_float_png_9 = new DecorationFloatingPoleLong(scene, 1098, 139);
    this.add(pole_long_float_png_9);

    // pole_long_float_png_14
    const pole_long_float_png_14 = new DecorationFloatingPoleLong(scene, 4011, 145);
    this.add(pole_long_float_png_14);

    // pole_long_float_png_15
    const pole_long_float_png_15 = new DecorationFloatingPoleLong(scene, 3586, 147);
    this.add(pole_long_float_png_15);

    // pole_long_float_png_16
    const pole_long_float_png_16 = new DecorationFloatingPoleLong(scene, 3010, 147);
    this.add(pole_long_float_png_16);

    // crateMarker_1
    const crateMarker_1 = new SmashableMarkerCrate(scene, 2615, -127);
    this.add(crateMarker_1);

    // crateMarker_2
    const crateMarker_2 = new SmashableMarkerCrate(scene, 3601, -123);
    this.add(crateMarker_2);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 354, -33);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 3836, -34);
    this.add(checkpointMarker_1);

    // platformMarkerLogKnot_1
    const platformMarkerLogKnot_1 = new PlatformMarkerLogKnot(scene, 2806, 12);
    this.add(platformMarkerLogKnot_1);

    // platformMarkerLogKnot_2
    const platformMarkerLogKnot_2 = new PlatformMarkerLogKnot(scene, 3798, 10);
    this.add(platformMarkerLogKnot_2);

    // platformMarkerBarrel
    const platformMarkerBarrel = new PlatformMarkerBarrel(scene, 2212, 46);
    this.add(platformMarkerBarrel);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 2217, -90);
    this.add(gemMarker);

    // platformMarkerBarrel_1
    const platformMarkerBarrel_1 = new PlatformMarkerBarrel(scene, 3314, -21);
    this.add(platformMarkerBarrel_1);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 3319, -157);
    this.add(gemMarker_1);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerJungleLog(scene, 1593, -269);
    this.add(platformLog_3);

    // platformLog
    const platformLog = new PlatformMarkerJungleLog(scene, 2743, -272);
    this.add(platformLog);

    // platformLog_1
    const platformLog_1 = new PlatformMarkerJungleLog(scene, 3730, -269);
    this.add(platformLog_1);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // crateMarker (components)
    const crateMarkerSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker);
    crateMarkerSimpleBreakableBlocker.allowedCharacter = "panda";

    // crateMarker_1 (components)
    const crateMarker_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_1);
    crateMarker_1SimpleBreakableBlocker.allowedCharacter = "ice";

    // crateMarker_2 (components)
    const crateMarker_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_2);
    crateMarker_2SimpleBreakableBlocker.allowedCharacter = "grizz";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
